import { render, staticRenderFns } from "./empty-layout.vue?vue&type=template&id=0ab738d7"
import script from "./empty-layout.vue?vue&type=script&lang=ts"
export * from "./empty-layout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports